module.exports = __webpack_public_path__ + "img/workout-notebook_B095Q4GJ7Y.d68da317.jpg";